/**
 * @desc js 小盾风控接入
 * @tgStorageTime 有效值缓存时间

 * 实际页面取值处理
 * localStorage.getItem('tongdunBlackBox') || '';
 */
import ISONLINE from './domainJudge';
import {
  blackBoxStorageTime as tgStorageTime, validBlackBoxMaxLength, degradedBlackBoxMaxLength,
  getAllowedBlackBoxMaxLength, readBlackBox, saveBlackBox, clearBlackBox
} from './tongdunCache';
// import { getFullUrl } from './utility';

/* eslint-disable no-underscore-dangle */

(function () {
  try {
    /** Web SDK 采集最长等待 15 秒，超时后仍接收并缓存合法迟到回调。 */
    const tongdunInitTimeout = 15000;
    const fmPath = '/tdfp/us/abe609b4e29f9410320db51f260cbc10/fm.js';
    const fmSrc = `https://static.trustdecision.com${fmPath}`;
    // 主 CDN 加载失败时，按当前站点域名选择对应的自有 CDN 回退地址。
    const fmLocalHost = window.location.hostname.indexOf('1v1chat.pro') > -1
      ? 'https://tdfp.1v1chat.pro'
      : 'https://tdfp.liveme.com';
    const fmLocalSrc = `${fmLocalHost}${fmPath}`;
    // 全局挂载
    if (!window.TONGDun) {
      window.TONGDun = {};
    }
    if (!window.TONGDun.time) {
      window.TONGDun.time = {};
    }
    const originClear = window.TONGDun.clear;
    const state = window.TONGDun._state || (window.TONGDun._state = {
      loading: false,
      ready: false,
      promise: null,
      callbacks: [],
      lastReason: '',
      lastBlackBoxLength: 0,
      /** 启动本轮采集前已有的缓存长度。 */
      storageBoxLength: 0,
      /** 同盾采集及存储链路记录的最后一个有效原因。 */
      sdkReason: '',
      // 标记当前同盾初始化轮次，隔离旧脚本的迟到回调。
      attemptId: 0,
      /** 本轮实际开始采集的时刻；缓存命中和加入等待不能重置。 */
      attemptStartTime: null,
      // 备用 CDN 结果：0 未回退，1 成功，2 加载失败，3 超时或未生成 black_box。
      fallbackResult: 0
    });

    /** 优先使用单调时钟，避免系统时间校准影响诊断耗时。 */
    const attemptNow = () => (window.performance && typeof window.performance.now === 'function' ? window.performance.now() : Date.now());
    /** 没有实际启动采集时不生成耗时；重试按新轮次重新计算。 */
    const getAttemptElapsed = () => (state.attemptStartTime == null ? undefined : Math.max(0, Math.round(attemptNow() - state.attemptStartTime)));

    /**
     * 记录当前调用的取值原因，不覆盖 SDK 采集及存储结果。
     * @param {string} reason 诊断原因
     */
    const markReadReason = function (reason) {
      state.lastReason = reason || state.lastReason || '';
      if (reason) {
        window.TONGDun.time.lastReason = reason;
      }
    };

    /**
     * 记录同盾运行时原因，供业务侧在 black_box 为空时读取并上报诊断。
     * @param {string} reason 诊断原因
     */
    const markReason = function (reason) {
      markReadReason(reason);
      if (reason) {
        if (reason !== 'td_storage_time_missing' && reason !== 'td_storage_expired') {
          /** 存储异常保留为独立根因，后续等待超时不能覆盖它。 */
          if (reason.indexOf('td_storage_') === 0 || String(state.sdkReason || '').indexOf('td_storage_') !== 0) {
            state.sdkReason = reason;
          }
        }
      }
    };

    /**
     * 记录本轮 SDK 原始返回长度，与已有缓存长度分开统计。
     * @param {string} blackBox 同盾 SDK 的原始 black_box
     * @returns {number} 原始长度
     */
    const recordRawBlackBoxLength = function (blackBox) {
      const rawLength = typeof blackBox === 'string' ? blackBox.length : 0;
      window.TONGDun.time.rawBlackBoxLength = rawLength;
      return rawLength;
    };

    /**
     * 根据调用场景过滤 black_box，默认 GET 场景不采用降级值。
     * @param {string} blackBox 同盾 black_box
     * @param {Object|boolean=} options 取值配置
     * @returns {string} 当前场景可使用的 black_box
     */
    const getUsableBlackBox = function (blackBox, options) {
      if (!blackBox || typeof blackBox !== 'string') {
        return '';
      }
      const maxLength = getAllowedBlackBoxMaxLength(options);
      if (blackBox.length > maxLength) {
        markReadReason('td_box_too_long');
        return '';
      }
      return blackBox;
    };

    /**
     * 清理已失效的同盾采集脚本，让无缓存场景可以重新执行一次采集。
     * @returns {void}
     */
    const removeFmScripts = function () {
      const scripts = document.getElementsByTagName('script');
      for (let index = scripts.length - 1; index >= 0; index -= 1) {
        const script = scripts[index];
        if (
          script.parentNode
          && (
            script.getAttribute('data-tongdun-fm') === '1'
            || (script.src && (script.src.indexOf(fmSrc) === 0 || script.src.indexOf(fmLocalSrc) === 0))
          )
        ) {
          script.parentNode.removeChild(script);
        }
      }
    };

    /** 通知同盾取值回调，避免回调异常中断状态收敛。 */
    const notifyCallback = function (callback, blackBox) {
      try {
        callback(blackBox);
      } catch (error) {
        console.log('tongdun callback error', error);
      }
    };

    /**
     * 结束初始化并通知等待队列。
     * @param {string} blackBox 当前调用可返回的同盾 black_box
     */
    const finishInit = function (blackBox) {
      state.loading = false;
      state.lastBlackBoxLength = typeof blackBox === 'string' ? blackBox.length : 0;
      state.ready = !!blackBox && blackBox.length <= validBlackBoxMaxLength;
      state.promise = null;
      state.callbacks.splice(0).forEach((callback) => {
        const item = callback && callback.callback ? callback : { callback };
        notifyCallback(item.callback, getUsableBlackBox(blackBox, item.options));
      });
    };

    // 清除缓存信息
    window.TONGDun.clear = function () {
      clearBlackBox(true);
      if (originClear && originClear instanceof Function) {
        try {
          originClear();
        } catch (error) {
          markReason('td_origin_clear_error', error);
        }
      }
      state.loading = false;
      state.ready = false;
      state.promise = null;
      state.callbacks.length = 0;
      state.attemptId += 1;
      state.attemptStartTime = null;
      state.lastBlackBoxLength = 0;
      state.storageBoxLength = 0;
      state.sdkReason = '';
      state.fallbackResult = 0;
      window.TONGDun.time.rawBlackBoxLength = 0;
      window.TONGDun.time.lastReason = '';
    };
    /**
     * 获取black_box方法
     * @param {boolean} checkExpired 是否检查过期时间
     * @returns {string} black_box
     */
    window.TONGDun.getBlackBox = function (checkExpired = false, options) {
      const read = {};
      const blackBox = readBlackBox(checkExpired, options, read);
      if (read.length) {
        state.lastBlackBoxLength = read.length;
      }
      if (read.reason) {
        markReadReason(read.reason);
      }
      return blackBox;
    };
    /**
     * 获取同盾运行时状态，供风控请求侧在空值时做诊断上报。
     * @returns {Object} 同盾运行时诊断状态
     */
    window.TONGDun.getStatus = function () {
      return {
        loading: !!state.loading,
        ready: !!state.ready,
        reason: state.lastReason || '',
        sdkReason: state.sdkReason || '',
        blackBoxLength: state.lastBlackBoxLength || 0,
        rawBlackBoxLength: Number(window.TONGDun.time.rawBlackBoxLength || 0),
        storageBoxLength: Number(state.storageBoxLength || 0),
        initTime: Number(window.TONGDun.time.initTime || 0),
        ableTime: Number(window.TONGDun.time.ableTime || 0),
        fmLoaded: Number(window.TONGDun.time.fmLoaded || 0),
        fmError: Number(window.TONGDun.time.fmError || 0),
        fallbackResult: Number(state.fallbackResult || 0),
        attemptElapsedMs: getAttemptElapsed()
      };
    };
    // 初始化方法
    window.TONGDun.init = function (success, options) {
      const callback = success && success instanceof Function ? success : null;
      // 开始同盾获取时间
      !window.TONGDun.time.initTime && (window.TONGDun.time.initTime = new Date().getTime());
      let tgEnv = 'test';
      if (ISONLINE) {
        tgEnv = 'online';
      }
      console.log('tongdun环境', tgEnv);

      // h5 （移动端） 或者 web （pc端）
      const UA = window.navigator.userAgent;
      const IsAndroid = /Android|HTC/i.test(UA);
      const IsIPad = !IsAndroid && (/iPad/i.test(UA) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream;
      const IsIPhone = !IsAndroid && /iPod|iPhone/i.test(UA);
      let tgType = 'web';
      if (IsAndroid || IsIPad || IsIPhone) {
        tgType = 'h5';
      }
      console.log('tongdun设备类型', tgType);

      // 渠道区分
      const tgMap = {
        online: {
          h5: {
            partner: 'mars',
            appName: 'mars_h5'
          },
          web: {
            partner: 'mars',
            appName: 'mars_web'
          }
        },
        test: {
          h5: {
            partner: 'mars',
            appName: 'mars_h5'
          },
          web: {
            partner: 'mars',
            appName: 'mars_web'
          }
        }
      };

      const { partner, appName } = tgMap[tgEnv][tgType];

      console.log('tongdun partner和appName', partner, appName);

      if (!state.promise) {
        state.sdkReason = '';
        state.lastReason = '';
      }
      const tgCurTime = new Date().getTime();
      const read = { readTime: true };
      const previousBlackBox = readBlackBox(false, { allowDegraded: true }, read);
      const tgPrevTime = read.time;
      if (read.reason === 'td_storage_get_error') {
        markReason(read.reason);
      }
      const tongdunBlackBox = getUsableBlackBox(previousBlackBox, options);
      const needsRefresh = !tongdunBlackBox || !tgPrevTime || tgCurTime - Number(tgPrevTime) >= tgStorageTime;
      if (tongdunBlackBox && !needsRefresh) {
        console.log('tongdun localStorage');
        // 同盾获取完成时间
        window.TONGDun.time.ableTime = new Date().getTime();
        state.lastBlackBoxLength = tongdunBlackBox.length;
        state.ready = tongdunBlackBox.length <= validBlackBoxMaxLength;
        if (callback) { notifyCallback(callback, tongdunBlackBox) }
        return Promise.resolve(tongdunBlackBox);
      }

      if (!state.promise && needsRefresh) {
        state.fallbackResult = 0;
        state.storageBoxLength = read.storageLength;
        window.TONGDun.time.fmError = 0;
        window.TONGDun.time.fmLoaded = 0;
        window.TONGDun.time.ableTime = 0;
        recordRawBlackBoxLength('');
      }

      // 刷新期间先交付已有值；只有没有可用值的调用方才等待采集结果。
      if (callback && tongdunBlackBox) { notifyCallback(callback, tongdunBlackBox) } else if (callback) {
        state.callbacks.push({ callback, options });
      }

      if (state.promise) {
        return tongdunBlackBox
          ? Promise.resolve(tongdunBlackBox)
          : state.promise.then(blackBox => getUsableBlackBox(blackBox, options));
      }

      if (needsRefresh) {
        console.log('tongdun init');
        state.loading = true;
        const attemptId = state.attemptId + 1;
        state.attemptId = attemptId;
        state.attemptStartTime = attemptNow();
        state.promise = new Promise((resolve) => {
          let finished = false;
          let timeoutTimer;
          const isCurrentAttempt = function () {
            return attemptId === state.attemptId;
          };
          /**
           * 只结束一次初始化，防止 success、onerror、轮询兜底重复触发。
           * @param {string} data 本轮采集可返回的同盾 black_box
           */
          const done = function (data) {
            if (finished || !isCurrentAttempt()) {
              return;
            }
            finished = true;
            clearTimeout(timeoutTimer);
            // 等待期间缓存可能达到硬上限，失败回退必须重新检查当前有效值。
            const finalBlackBox = data || readBlackBox(false, { allowDegraded: true });
            finishInit(finalBlackBox);
            resolve(finalBlackBox);
          };
          // 远端脚本加载成功但没有触发 success 时，释放初始化状态。
          let fallbackStarted = false;
          timeoutTimer = setTimeout(() => {
            if (!isCurrentAttempt()) {
              return;
            }
            if (fallbackStarted && !state.fallbackResult) {
              state.fallbackResult = 3;
            }
            markReason(fallbackStarted ? 'fm_js_load_error' : 'td_init_timeout');
            done(window.TONGDun.getBlackBox(true, options) || '');
          }, tongdunInitTimeout);
          // 先废弃上一轮回调，避免已移除脚本的迟到回调继续触发旧流程。
          const previousFmOpt = window._fmOpt;
          if (previousFmOpt && typeof previousFmOpt.success === 'function') {
            previousFmOpt.success = function () {};
          }
          window._fmOpt = {
            partner,
            appName,
            // token: `tongdun-${new Date().getTime()}-${Math.random().toString(16).substr(2)}`,
            // fpHost: 'https://usfp.tongdun.net',
            // fmb: true,
            success(data) {
              if (!isCurrentAttempt()) {
                return;
              }
              const blackBox = typeof data === 'string' ? data : '';
              const validBlackBox = !!blackBox && blackBox.length <= degradedBlackBoxMaxLength;
              if (finished) {
                // 已结算轮次的无效回调不能清除后续可用缓存。
                if (!validBlackBox) { return }
                // 迟到回调属于正常采集结果，只恢复缓存，不作为 kewlweb_onerror 上报。
                if (!isCurrentAttempt()) { return }
              }
              // 仅 SDK 当前轮次的成功回调可更新采集结果和保存时间。
              recordRawBlackBoxLength(blackBox);
              if (validBlackBox) {
                if (fallbackStarted) {
                  state.fallbackResult = 1;
                }
                window.TONGDun.time.ableTime = new Date().getTime();
                // localStorage 处理
                markReason(blackBox.length <= validBlackBoxMaxLength ? 'td_init_success' : 'td_init_degraded_success');
                const storageReason = saveBlackBox(blackBox, window.TONGDun.time.ableTime);
                if (storageReason) {
                  markReason(storageReason);
                }
                // success 已通过轮次校验，迟到值也更新后续请求读取的可用状态。
                if (finished) {
                  state.lastBlackBoxLength = blackBox.length;
                  state.ready = blackBox.length <= validBlackBoxMaxLength;
                }
              } else {
                if (fallbackStarted) {
                  state.fallbackResult = 3;
                }
                console.log('tongdun black_box: ', '当前为降级值');
                markReason(blackBox ? 'td_box_too_long' : 'td_empty_callback');
                if (!readBlackBox(false, { allowDegraded: true })) {
                  const storageReason = clearBlackBox();
                  if (storageReason) {
                    markReason(storageReason);
                  }
                }
              }
              done(validBlackBox ? blackBox : '');
            }
          };

          removeFmScripts();
          const fm = document.createElement('script');
          fm.type = 'text/javascript';
          fm.async = true;
          fm.setAttribute('data-tongdun-fm', '1');
          // const fsrc = (tgEnv == 'online') ? getFullUrl('/app/js/dist/fm.js') : '//nqa.liveme.com/app/js/dist/fm.js';
          const fmVersion = (new Date().getTime() / 3600000).toFixed(0);
          fm.src = `${fmSrc}?t=${fmVersion}`;
          const s = document.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(fm, s);
          fm.onload = () => {
            if (finished || !isCurrentAttempt()) {
              return;
            }
            // fm.js加载完成时间
            window.TONGDun.time.fmLoaded = new Date().getTime();
          };
          fm.onerror = () => {
            if (finished || !isCurrentAttempt()) {
              return;
            }
            // 主 CDN 失败后仅回退一次；最终结果仍由同一 done 结算，避免重复上报。
            if (fallbackStarted) {
              return;
            }
            fallbackStarted = true;
            window.TONGDun.time.fmError = new Date().getTime();
            markReason('fm_js_load_error');
            if (fm.parentNode) {
              fm.parentNode.removeChild(fm);
            }
            const fmLocal = document.createElement('script');
            fmLocal.type = 'text/javascript';
            fmLocal.async = true;
            fmLocal.setAttribute('data-tongdun-fm', '1');
            fmLocal.src = `${fmLocalSrc}?t=${fmVersion}`;
            fmLocal.onload = () => {
              if (finished || !isCurrentAttempt()) {
                return;
              }
              // 本地回退脚本加载完成后，继续等待同盾 success 回调。
              window.TONGDun.time.fmLoaded = new Date().getTime();
            };
            fmLocal.onerror = () => {
              if (finished || !isCurrentAttempt()) {
                return;
              }
              // 主、备 CDN 均失败时沿用原有空值和埋点处理。
              state.fallbackResult = 2;
              markReason('fm_js_load_error');
              if (fmLocal.parentNode) {
                fmLocal.parentNode.removeChild(fmLocal);
              }
              done('');
            };
            const localScript = document.getElementsByTagName('script')[0];
            if (localScript && localScript.parentNode) {
              localScript.parentNode.insertBefore(fmLocal, localScript);
            } else {
              state.fallbackResult = 2;
              done('');
            }
          };
        });
        return tongdunBlackBox
          ? Promise.resolve(tongdunBlackBox)
          : state.promise.then(blackBox => getUsableBlackBox(blackBox, options));
      }
      return Promise.resolve(tongdunBlackBox || '');
    };
    // 防止重复初始化
    !window._fmOpt && window.TONGDun.init();
  } catch (err) {
    console.log('tongdun-err', err);
  }
}());
